<template>
  <b-card class="border-primary">
    <h4 class="mb-1">معلومات المنظمة</h4>

    <div
      style="gap: 15px"
      class="d-flex align-items-center justify-content-start"
    >
      <b-avatar class="shadow-sm" :src="ngo.logo" size="90px" rounded />

      <ul class="list-unstyled mr-1">
        <li>
          <b-link
            :to="{ name: 'ngo-home', params: { id: ngo.id } }"
            class="align-middle"
            >{{ ngo.name_ar }}</b-link
          >
        </li>
        <li class="my-25">
          <span class="align-middle">
            رقم قرار الإشهار :
            {{ ngo.decision_no }}</span
          >
        </li>
        <li class="my-25">
          <span class="align-middle">
            الشكل القانوني :
            {{ ngo.legalForm ? ngo.legalForm.name_ar : "" }}</span
          >
        </li>
      </ul>
    </div>
  </b-card>
</template>

<script>
import {
  BCard,
  BAvatar,
  BCardHeader,
  BCardBody,
  BBadge,
  BButton,
  BLink,
} from "bootstrap-vue";
import Ripple from "vue-ripple-directive";

export default {
  directives: {
    Ripple,
  },
  props: {
    ngo: Object,
  },
  components: {
    BCard,
    BAvatar,
    BCardHeader,
    BCardBody,
    BBadge,
    BButton,
    BLink,
  },
};
</script>

<style></style>
